// Initial state
const state = {
  baseUrl: '/lib',
  docsUrl: '/lib/dist/docs/api.json',
  loaded: false
};

// getters
const getters = {
};

// actions
const actions = {
};

// mutations
const mutations = {
  loaded (state, value) {
    state.loaded = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
